import { createFileRoute } from '@tanstack/react-router';
import { ProductLicenseDetail } from '@/routes/_staff/marketplace/_store/store/licenses/$productId/-components/ProductLicenseDetail';
export const Route = createFileRoute('/_staff/marketplace/_store/store/licenses/$productId/')({
  component: ProductLicenseDetail
});